import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faFaceLaugh,
  faPaperclip,
  faAngleDown,
  faAngleUp,
  faArrowCircleDown,
  faHeart,
  faStar as faStarLight,
  faSpinner,
} from '@fortawesome/pro-light-svg-icons'
import {
  faChevronRight,
  faCompress,
  faExpand,
  faLongArrowLeft,
  faLongArrowRight,
  faLongArrowAltDown,
  faStar as faStarRegular,
  faWindowMinimize,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faStar as faStarSolid,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faChevronRight,
  faCompress,
  faExpand,
  faAngleDown,
  faAngleUp,
  faLongArrowLeft,
  faLongArrowRight,
  faLongArrowAltDown,
  faArrowCircleDown,
  faHeart,
  faPaperclip,
  faFaceLaugh,
  faWindowMinimize,
  faStarRegular,
  faStarLight,
  faStarSolid,
  faSpinner,
  faXmark,
)

// console.log(library.definitions)

export default FontAwesomeIcon
